import { Component } from '@angular/core';
import { LeftPanelService } from '../services/left-panel.service';

@Component({
  selector: 'lfwms-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
/*@author: abidhmuhsinp
*/
export class HeaderComponent {

  constructor(public leftPanelService: LeftPanelService) { }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/header/header.component.ts